/**
 * 功能：“时间”类型数据转换
 * 参数：
 *      time-input-format： 输入格式（默认：自动识别）
 *      time-output-forma： 输出格式（默认：YYYY-MM-DD HH:mm:ss）
 */

import moment from 'moment';

export function format(column, value)
{
  let inputFormat = column.timeInputFormat;
  let outputFormat = column.timeOutputFormat;
  // 是否null值
  if (value == null)
    return null;
  // 参数处理
  if (typeof (outputFormat) == "undefined")
    outputFormat = "YYYY-MM-DD HH:mm:ss";
  // 格式转换
  return moment(value, inputFormat).format(outputFormat);
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableColumn/Slot/Time.js